import React from "react";
import {
  tooltipButtons,
  TooltipChecklist as tooltipChecklistItems,
} from "../../../NewConstants/TooltipConstants";

const TooltipChecklist = ({
  selectedLanguage,
  setShowTooltipChecklist,
  setStartTour,
}) => {
  return (
    <div className="tooltip-checklist fixed top-0 left-0 w-screen h-screen flex flex-col items-center justify-center z-[1000] bg-white pb-safe">
      <div className="w-full h-[3.75rem] flex items-center justify-start py-4 px-6 border-b border-gray-200 bg-white z-10">
        <button
          className="text-2xl font-bold text-gray-700 hover:text-black focus:outline-none"
          onClick={() => setShowTooltipChecklist(false)}
          aria-label="Close Tooltip Checklist"
        >
          <div className="text-lg font-semibold ml-4 flex items-center">
            <img
              src="/Assets/Images/arrowLeftBlack.svg"
              alt="Back Arrow"
              className="w-8 h-8 mr-2"
            />
            {tooltipButtons.backToChat[selectedLanguage]}
          </div>
        </button>
      </div>
      <div
        className="flex-1 w-full flex flex-col items-center justify-start gap-4 overflow-y-auto pt-4 pb-4"
        style={{ backgroundImage: `url("/Assets/Images/bgWallpaper.svg")` }}
      >
        {tooltipChecklistItems.map((item) => (
          <div key={item.key} className="w-[90%]">
            <div className="w-full h-[8.813rem]  rounded-xl bg-white border border-gray-200 shadow-sm flex flex-col items-center justify-center overflow-hidden gap-2">
              <img
                src={item.img}
                alt={item.title?.[selectedLanguage] || item.title?.en}
                className="h-[5.188rem] object-contain"
              />
              <div className="h-[1.875rem] w-full pl-3 flex flex-col items-start justify-center">
                <p className="w-[262px] h-[18px] opacity-100 font-anek font-semibold text-[16px] leading-[100%] tracking-normal text-gray-700">
                  {item.title?.[selectedLanguage] || item.title?.en}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center w-full h-[5.375rem] px-4">
        <button
          className="w-full max-w-[20.5rem] h-[3.375rem] rounded-[1rem] bg-[var(--primary-dark)] text-white shadow-sm flex items-center justify-center gap-3 active:opacity-90"
          onClick={() => {
            setStartTour(true);
            setShowTooltipChecklist(false);
          }}
        >
          <span className="text-[16px] font-semibold">
            {tooltipButtons.TooltipStart[selectedLanguage] ||
              tooltipButtons.TooltipStart.en}
          </span>
          <span className="flex items-center gap-1">
            <img
              src="/Assets/Images/Tooltip/TooltipCheckList/PlayPause.svg"
              alt="play pause"
            />
          </span>
        </button>
      </div>
    </div>
  );
};

export default TooltipChecklist;
